// src/i18n/es/reservationStates.ts
// Single source of truth for the primary `ReservationState.state` labels
// (proposal §3, definitive vocabulary). Every screen that shows a state chip
// (Llegadas de hoy, Reservas, the reservation detail header) must read from
// here — never invent a label inline.
export const reservationStates = {
  notStarted: 'Sin empezar',
  preCheckInPartial: 'Pre-check-in a medias',
  preCheckInDone: 'Pre-check-in hecho',
  arrivesToday: 'Llega hoy',
  liveKiosk: 'En el kiosco',
  liveMobileKiosk: 'En el kiosco en el móvil',
  liveAirLobby: 'Con recepción (Air Lobby)',
  needsHelp: 'Necesita ayuda',
  checkedInKiosk: 'Check-in hecho en el kiosco',
  checkedInMobileKiosk: 'Check-in hecho en el kiosco en el móvil',
  checkedInAirLobby: 'Check-in hecho con Air Lobby',
  keyDelivered: 'Llave entregada',
  kioskLeftMidway: 'Se quedó a medias en el kiosco',
  noRecord: 'Sin check-in registrado',
  inHouse: 'Alojado',
  departed: 'Salió',
};

export default reservationStates;
